import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./AdminAuth.css";

function ForgotPassword() {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const handleReset = (e) => {
    e.preventDefault();

    const storedUser = JSON.parse(localStorage.getItem("user"));

    if (!storedUser || email !== storedUser.email) {
      alert("Invalid email! Please enter the registered email id.");
      return;
    }

    if (newPassword !== confirmPassword) {
      alert("Password does not match");
      return;
    }

    storedUser.password = newPassword;
    localStorage.setItem("user", JSON.stringify(storedUser));

    alert("Password updated successfully!");
    navigate("/login");
  };

  return (
    <form onSubmit={handleReset}>
      <h2>Forgot Password</h2>

      <input
        type="email"
        placeholder="Registered Email"
        onChange={(e) => setEmail(e.target.value)}
        required
      />
      <br />

      <input
        type="password"
        placeholder="New Password"
        onChange={(e) => setNewPassword(e.target.value)}
        required
      />
      <br />

      <input
        type="password"
        placeholder="Confirm Password"
        onChange={(e) => setConfirmPassword(e.target.value)}
        required
      />
      <br />

      <button type="submit">Reset Password</button>
    </form>
  );
}

export default ForgotPassword;
